module.exports = __webpack_public_path__ + "media/images/icon-back-black@3x-ebb9580b1a63a655e50a0d36b2bd144f.png";